const AUTH_PREPARATION = "/v1/users/auth-preparation-v2";

export const PATH_AUTHENTICATION = {
    AUTH_PREPARATION : AUTH_PREPARATION
} 



